export default __webpack_public_path__ + "static/media/03_Mini_Game.2cf2364c.png";